// Shariff
var Shariff = require('shariff');
$(document).ready(function() {
  if($('.shariff').length) {
    var buttonsContainer = $('.shariff');
    var sh = new Shariff(buttonsContainer, {
        orientation: 'vertical',
        services: ['facebook','twitter']
    });
    $('.shariff-button a').attr('target','_blank');
  }
  $('button.copy-link').click(function(e) {
    e.preventDefault();
    copyLink();
  });
  $('a.copy-link').attr('href','javascript:copyLink()');
});

// Copy Link
function copyLink() {
  var inputc = document.body.appendChild(document.createElement("input"));
  inputc.value = window.location.href;
  inputc.focus();
  inputc.select();
  document.execCommand('copy');
  inputc.parentNode.removeChild(inputc);
  alert('Der Link wurde in Ihre Zwischenablage kopiert.');
}
